module.exports = __webpack_public_path__ + "static/media/icon-bodytype.037b4777.svg";